module.exports = __webpack_public_path__ + "img/js.980ad8da.svg";